import { random } from 'lodash';
import { z } from 'zod';
import { legalTransactionRelationshipRealEstateInventoryOptionSchema } from './ILegalTransactionRelationshipRealEstateInventoryOption';
import { legalTransactionRelationshipRealEstatePropertyTypeSchema } from './ILegalTransactionRelationshipRealEstatePropertyType';
import { legalClientSchema } from '../../ILegalClient';
import { landParcelEntrySchema } from '../../IRealEstate';

export const legalTransactionRelationshipRealEstateSchema = z.object({
  Street: z.string().nullable(),
  StreetNr: z.string().nullable(),
  StreetAditional: z.string().nullable(),
  Latitude: z.number().nullable(),
  Longitude: z.number().nullable(),
  idPostcode: z.number().nullable(),
  Postcode: z.string().optional(),
  City: z.string().optional(),
  Area: z.number().nullable(),
  BuildWith: z.string().nullable(),
  Defect: z.string().nullable(),
  EasementText: z.string().nullable(),
  InventoryOptionArray: z.array(
    legalTransactionRelationshipRealEstateInventoryOptionSchema
  ),

  OrderMeasurement_idPurchaseContractRelationType: z.number().nullable(),

  LandParcelEntryArray: z.array(landParcelEntrySchema),

  Particularities: z.string().nullable(),
  PaymentMeasurement_idPurchaseContractRelationType: z.number().nullable(),
  BuildingManager_idLegalClient: z.number().nullable(),
  Price: z.number(),
  PriceInventoryOption: z.number().nullable(),
  PropertyTypeArray: z.array(
    legalTransactionRelationshipRealEstatePropertyTypeSchema
  ),
  SheetLandRegister: z.string(),
  hasApartment: z.boolean(),
  hasEasement: z.boolean(),
  hasPartialArea: z.boolean(),
  idAddress: z.number().nullable(),
  idCourt: z.number().nullable(),
  idRealEstate: z.number(),
  idRealEstateUseType: z.number().min(1),
  idRelationship: z.number().nullable(),
  isBuild: z.boolean(),
  isMeasured: z.boolean(),

  requiresClearance: z.boolean(),
  clearanceDate: z.string().nullable(),
  isRented: z.boolean(),
  rentedPersonArray: z.array(legalClientSchema),
});

export type ILegalTransactionRelationshipRealEstate = z.infer<
  typeof legalTransactionRelationshipRealEstateSchema
>;

export const initRealEstate = (): ILegalTransactionRelationshipRealEstate => ({
  idRealEstate: -random(1, Number.MAX_SAFE_INTEGER),
  Street: null,
  StreetNr: null,
  StreetAditional: null,
  idPostcode: null,
  Latitude: null,
  Longitude: null,
  Area: null,
  BuildWith: null,
  Defect: null,
  EasementText: null,
  InventoryOptionArray: [],
  LandParcelEntryArray: [],
  OrderMeasurement_idPurchaseContractRelationType: null,
  Particularities: null,
  PaymentMeasurement_idPurchaseContractRelationType: null,
  BuildingManager_idLegalClient: null,
  Price: 0,
  PriceInventoryOption: null,
  PropertyTypeArray: [],
  SheetLandRegister: '',
  hasApartment: false,
  hasEasement: false,
  hasPartialArea: false,
  idAddress: null,
  idCourt: null,
  idRealEstateUseType: 1,
  idRelationship: null,
  isBuild: false,
  isMeasured: false,

  requiresClearance: false,
  clearanceDate: '',
  isRented: false,
  rentedPersonArray: [],
});
